import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { debugMessage } from './common'
import { hideBootSplash } from './lib/bootSplash'

function Login() {
  const navigate = useNavigate()

  useEffect(() => {
    debugMessage('Mounted', 'Login :: Logging in ...')
    hideBootSplash()
    // Cognito returns here. The root loader has already parsed tokens.
    // Stay in-app so a pending Quick Start action in localStorage is processed.
    navigate('/action', { replace: true })
  }, [navigate])

  return <></>
}

export { Login }
